/* Used by DataTables for field selection */
import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/store/EventBus.js